<ng-container *ngIf="muestraTarjeta">
  <div class="blog">
    <div class="cabecera-blog">
      <app-skeleton-image class="blogimg" [size]="120" [src]="data?.foto" [aspectRatio]="'1'" [customClass]="'imagen-autor'" [lazy]="false"> </app-skeleton-image>

      <h2>{{ data?.titulo }}</h2>

      <ng-container *ngIf="data?.subTitulo">
        <h4 class="subTitulo">{{ data?.subTitulo }}</h4>
      </ng-container>

      <ng-container *ngIf="data?.bio">
        <div class="biografia" [innerHTML]="data?.bio"></div>
      </ng-container>

      <ng-container *ngIf="data?.redes">
        <div class="redes">
          <div class="row">
            <ng-container *ngIf="data?.twitter">
              <a href="https://twitter.com/{{ data?.twitter }}" target="_blank">
                <h4 class="item">
                  <img class="icon twitter" alt="twitter" src="assets/images/x.svg" loading="lazy" width="100%" height="100%" />
                  <span>{{ data.twitter }}</span>
                </h4>
              </a>
            </ng-container>
            <ng-container *ngIf="data?.instagram">
              <a href="https://instagram.com/{{ data?.instagram }}" target="_blank">
                <h4 class="item">
                  <img class="icon instagram" alt="instagram" src="assets/images/insta-icon.svg" loading="lazy" width="100%" height="100%" />
                  <span>{{ data?.instagram }}</span>
                </h4>
              </a>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
